import { useTranslation } from 'react-i18next';
import { ReactComponent as PenIcon } from 'assets/icons/pen.svg';
import { ReactComponent as TrashIcon } from 'assets/icons/tresh.svg';
import Button from 'components/Button/Button';
import EditTopicName from 'components/EditTopicName/EditTopicName';
import IconButton from 'components/IconButton/IconButton';
import KeywordItem from 'components/KeywordItem/KeywordItem';
import Tooltip from 'components/Tooltip/Tooltip';
import { BUTTON_VARIANT } from 'constants/interfaces';

import type ITopicRow from '../interfaces/ITopicRow';

import styles from '../scss/TopicRow.module.scss';

function TopicRow({
  topic,
  openEditField,
  selectedItem,
  text,
  onChangeText,
  onSaveTopic,
  onCancel,
  openKeywordsField,
  onOpenFieldKeyWords,
  onSaveKeyWords,
  onDeleteKeyword,
  onEditTopicName,
  onDeleteItem,
}: Readonly<ITopicRow>) {
  const { t } = useTranslation();

  return (
    <div className={styles.topicRow}>
      <span className={styles.topicCell}>
        {openEditField && selectedItem === topic.id
          ? (
            <EditTopicName
              text={text}
              placeholder={t('standards.typeHere')}
              onChangeText={onChangeText}
              onSave={onSaveTopic}
              onCancel={onCancel}
              saveTitle={t('common.save')}
              cancelTitle={t('common.cancel')}
            />
          )
          : <p>{topic.title}</p>}
      </span>
      <div className={styles.topicCell}>
        {openKeywordsField && selectedItem === topic.id
          ? (
            <div className={styles.editWrapper}>
              <EditTopicName
                text={text}
                placeholder={t('standards.typeHere')}
                onChangeText={onChangeText}
                onSave={onSaveKeyWords}
                onCancel={onCancel}
                saveTitle={t('common.save')}
                cancelTitle={t('common.cancel')}
                keyWordsType
              />
            </div>
          )
          : (
            <Button
              title={t('standards.addKeySearch')}
              variant={BUTTON_VARIANT.ghost}
              onClick={() => onOpenFieldKeyWords(topic.id || -1)}
              className={styles.buttonAdd}
            />
          )}
        <div className={styles.keywordsWrapper}>
          {topic.keywords.map((keyword, index) => (
            <KeywordItem
              key={[keyword, index].join('_')}
              keyword={keyword}
              className={styles.keywordWhite}
              onRemove={() => onDeleteKeyword(topic.id || -1, keyword)}
            />
          ))}
        </div>
      </div>
      <div className={styles.topicCell}>
        <Tooltip className={styles.tooltip} hint={t('standards.editName')}>
          <IconButton
            className={styles.editIcon}
            icon={<PenIcon />}
            onClick={() => onEditTopicName(topic.id || -1)}
          />
        </Tooltip>
        <Tooltip className={styles.tooltip} hint={t('standards.delete')}>
          <IconButton
            className={styles.deleteIcon}
            icon={<TrashIcon />}
            onClick={() => onDeleteItem(topic.id || -1)}
          />
        </Tooltip>
      </div>
    </div>
  );
}

export default TopicRow;
